import React, { Component } from 'react';
import searchImg from '../assets/fonts/search.png';

export default class EmptyReport extends Component {
  render() {
    return (
      <div
        style={{
          position: 'relative',
          textAlign: 'center',
          width: this.props.width,
          height: this.props.height
        }}
      >
        <img
          style={{
            width: '150px',
            height: '100px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginLeft: '-75px',
            marginTop: '-50px',
          }}
          src={searchImg} >
        </img>
        <span
          style={{
            color: '#666',
            fontSize: '14px',
            position: 'absolute',
            width: '100%',
            display: 'block',
            top: '50%',
            marginTop: '60px'
          }}
        >
          当前报表无数据
        </span>
      </div>
    )
  }
}